var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconAnalysis24Line = function SvgIconAnalysis24Line(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.1 17.9-2.63-2.63a6.559 6.559 0 0 0 1.38-4.02c0-3.64-2.96-6.6-6.6-6.6-3.64 0-6.6 2.96-6.6 6.6 0 3.64 2.96 6.6 6.6 6.6 1.515 0 2.905-.52 4.02-1.38l2.63 2.63 1.2-1.2Zm-7.85-1.75c-2.7 0-4.9-2.2-4.9-4.9s2.2-4.9 4.9-4.9 4.9 2.2 4.9 4.9-2.2 4.9-4.9 4.9Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.35 11h-1.7v2.5h1.7V11ZM12.1 8.5h-1.7v5h1.7v-5ZM14.85 10h-1.7v3.5h1.7V10Z",
    fill: "current"
  })));
};
export default SvgIconAnalysis24Line;